import { createContext } from "react";

const bloqueosContext = createContext();

export default bloqueosContext;
